import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

import { ISelect } from '../../atoms/select/select.interface';

import { customSelectRequiredValidator } from '../../../shared/helpers/validators/select.required/validators.select.required';

@Component({
    selector: 'mlp-ng-city-select',
    templateUrl: './city-select.component.html',
    styleUrls: ['./city-select.component.scss'],
})

export class CitySelectSharedComponent {
    @Input() options: Array<ISelect> = [];

    @Output() submitted: EventEmitter<string> = new EventEmitter();
    @Output() changed: EventEmitter<string> = new EventEmitter();
    form: FormGroup;

    get city(): AbstractControl { return this.form.get('city'); }

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            city: [{
                description: 'Select City',
                data: null
            }, customSelectRequiredValidator()]
        });

        this.form.controls['city'].valueChanges.subscribe(value => {
            this.changed.emit(value);
        });
    }

    submit(): void {
        this.submitted.emit(this.form.controls['city'].value);
    }

}
